module.exports = __webpack_public_path__ + "img/history.e1d41e08.png";